import React from 'react'
import './Thankyou.css'

export default function Thankyou() {
  return (
    <>
    {/* <!DOCTYPE html> */}
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
  <title>Thank You | Shivam Digital</title>
  <link rel="stylesheet" href="thankyou.css" />
</head>
<body>
  <div class="thankyou-container">
    <div class="thankyou-box">
      <h1>🎉 Thank You!</h1>
      <p>Your message has been received. I'll get back to you in 24 hour.</p>
      <a href="/" class="home-btn">← Back to Home</a>
    </div>
  </div>
</body>
</html>

    </>
  )
}
